import { GroupCodeApi } from '../api'
import { parseApiErrorDetails } from '../utils/parseApiError'
import { getApiConfig } from './api-config'

export class GroupCodeRedeemError extends Error {
  status?: number
  statusText?: string
  url?: string
  body?: unknown
  rawResponseText?: string
  redeemCode: string

  constructor(
    message: string,
    {
      body,
      rawResponseText,
      redeemCode,
      status,
      statusText,
      url,
    }: {
      status?: number
      statusText?: string
      url?: string
      body?: unknown
      rawResponseText?: string
      redeemCode: string
    },
  ) {
    super(message)
    this.name = 'GroupCodeRedeemError'
    this.status = status
    this.statusText = statusText
    this.url = url
    this.body = body
    this.rawResponseText = rawResponseText
    this.redeemCode = redeemCode
  }
}

export async function redeemGroupCode(code: string) {
  const api = new GroupCodeApi(getApiConfig())
  try {
    await api.apiGroupcodeRedeemPost({ code })
  } catch (e) {
    const details = await parseApiErrorDetails(e, 'Failed to redeem code')

    throw new GroupCodeRedeemError(details.message, {
      status: details.status,
      statusText: details.statusText,
      url: details.url,
      body: details.body,
      rawResponseText: details.rawResponseText,
      redeemCode: code,
    })
  }
}
